import { baseApi } from "../baseApi";

export const globalapi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDoctypeCount: builder.query({
      query: (doctype) => ({
        url: `/api/method/frappe.client.get_count`,
        params: { doctype },
      }),
    }),
    getDoctypePrint: builder.query({
      query: (params) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.generate_pdf`,
        params,
        headers: {
          Accept: "application/pdf",
        },
        responseHandler: (response) => response.blob(),
      }),
    }),
    getDoctypePrintType: builder.query({
      query: (params) => ({
        url: `/api/resource/Print Format`,
        params,
      }),
    }),
    postUploadFile: builder.mutation({
      query: (body) => ({
        url: `/api/method/upload_file`,
        method: "POST",
        body,
      }),
    }),
    getDeleteUploadFile: builder.mutation({
      query: ({ fid, dt, dn }) => ({
        url: `/api/method/frappe.desk.form.utils.remove_attach`,
        method: "GET",
        params: { fid, dt, dn },
      }),
    }),

    getDocFieldsWithVisibility: builder.query({
      query: (doc) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_doc_fields_with_visibility`,
        params: { doc },
      }),
    }),
    getDocOfAttachment: builder.query({
      query: (doc) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.react_api.get_attachments_for_doc`,
        params: doc,
      }),
    }),

       deleteDoc: builder.mutation({
      query: ({ doctype, name }) => ({
        url: `/api/method/frappe.client.delete`,
        method: "DELETE",
        params: { doctype, name },
      }),
    }),

  }),
});

export const {
  useGetDoctypeCountQuery,
  useGetDoctypePrintQuery,
  usePostUploadFileMutation,
  useGetDocOfAttachmentQuery,
  useGetDoctypePrintTypeQuery,
  useGetDeleteUploadFileMutation,
  useGetDocFieldsWithVisibilityQuery,
  useDeleteDocMutation
} = globalapi;
